import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { useDeleteMutation } from '../../../hooks/useAuthenticatedMutation';

const DeleteTopicDialog = ({ onClose, topic }) => {
    const deleteMutation = useDeleteMutation(`topics/${topic.id}`, 'topics');

    const handleDelete = e => {
        e.preventDefault();
        deleteMutation.mutate({ onSuccess: onClose });
    };

    return (
        <Dialog onClose={onClose} open={true}>
            <form onSubmit={handleDelete}>
                <DialogTitle>Delete Topic: {topic.name}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Please confirm this action.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        loading={deleteMutation.isPending}
                        loadingPosition="start"
                    >
                        Confirm delete
                    </Button>
                    <Button variant="outlined" onClick={onClose}>Cancel</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default DeleteTopicDialog;